import clsx from 'clsx';

export function Card({
	children,
	className,
}: {
	children: React.ReactNode;
	className?: string;
}) {
	return (
		<div
			className={clsx(
				'border border-gray-200 bg-white p-5 shadow-sm sm:rounded-xl md:p-8',
				className,
			)}
		>
			{children}
		</div>
	);
}
